import { render } from "./App.vue?vue&type=template&id=c7627f2e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c7627f2e&lang=css"

import exportComponent from "/Users/jason/code/feproj/seedling/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__